



































































































































import { Component } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import ErrorController from "@/resources/mixins/errorController/errorController";

@Component({})
export default class LoginComponent extends mixins(
  NotificationEvent,
  ErrorController
) {
  @Validate({ required, email })
  username = "";
  @Validate({ required })
  password = "";
  @Validate({ required })
  dniOrNie = "";
  hasVisiblePassword = false;
  loading = false;
  mounted(): void {
    const email: string = this.$route.query.email as string;
    const password: string = this.$route.query.password as string;
    const space: string = this.$route.query.space as string;
    if (space) {
      localStorage.setItem("space_default", space);
    }
    if (email && password) {
      this.username = email;
      this.password = password;
      this.onLogin();
    }
    /*if (this.dniOrNie && password) {
      this.dniOrNie = dniOrNie;
      this.password = password;
      this.onLoginGicar();
    }*/
  }
  onLogin(): void {
    this.loading = true;
    this.$store.dispatch("AuthStore/loginAction", {
      props: { email: this.username.toLowerCase(), password: this.password },
      callback: () => {
        localStorage.setItem("email", this.username.toLowerCase());
        this.loading = false;
      },
      callbackError: (error) => {
        this.loading = false;
        if (error.response && error.response.status == 401)
          this.checkError(error);
        else
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
      },
    });
  }
  onLoginGicar(): void {
    console.log("TTT onLoginGicar", this.dniOrNie, " ", this.password);
    this.loading = true;
    this.$store.dispatch("AuthStore/loginGicarAction", {
      props: { dniOrNie: this.dniOrNie, password: this.password },
      callback: (response) => {
        console.log("TTT onLoginGicar OK ", response);
        this.loading = false;
      },
      callbackError: (error) => {
        this.loading = false;
        console.log("TTT onLoginGicar KO ", error);
      },
    });
  }
  isHawkings() {
    if (window.location.host.includes("hawkings.education")) {
      return true;
    }
    return false;
  }
  isCTTI() {
    if (window.location.host.includes("ctti.nubi")) {
      return true;
    }
    return false;
  }
}
